import { createSelector } from 'reselect'

export const getItems = createSelector(
  (state) => state.items,
  items => items
);

export const getFilters = createSelector(
  (state) => state.subcompanies,
  ({filters}) => filters
);

export const getCount = createSelector(
  (state) => state.subcompanies.total_count,
  (total_count) => total_count
);

export const getFiltersSchema = createSelector(
  (state) => state.subcompanies,
  ({filtersSchema}) => filtersSchema
);

